import * as React from 'react';
import { nonPiletInstances } from '../../configs/config';
import Tile from '../Tile';
import { isEmpty, get } from 'lodash';
import { getItem } from '../../Utils/Storage';
import { STORAGE_KEYS } from '../../Utils/constants';
import { Route } from 'react-router';
import { instance } from '../../Utils/configuration';
import { gamification } from '../../api/event';

const DashboardContainer = ({ children }) => {
  const userInfo = getItem(STORAGE_KEYS.AUTH_CONFIG);

  const isAuthorised = !isEmpty(userInfo);

  const onSetFrame = (app) => {
    history.pushState('', '', app.path);

    var popStateEvent = new PopStateEvent('popstate', {});
    dispatchEvent(popStateEvent);
    gamification({
      type: `OPEN_${app.appName}`,
      event: 'OPEN_APP'
    });
  };
  return (
    <div
      className='flex'
      style={{
        display: 'flex',
        flexWrap: 'wrap',
        margin: '32px 16px'
      }}
    >
      {isAuthorised &&
        nonPiletInstances.map((instance: any) => (
          <Tile instance={instance} onSetFrame={onSetFrame} />
        ))}
      {children}
    </div>
  );
};

export default DashboardContainer;
